export const engagementCanvasesForClickedShortenedSmsLink = "/engagement/canvases_for_clicked_shortened_sms_link";
